import {Button} from "@zendeskgarden/react-buttons";
import {Inline} from "@zendeskgarden/react-loaders";
import {Body, Close, Footer, FooterItem, Header, Modal} from "@zendeskgarden/react-modals";
import {ReactElement} from "react";
import * as css from "../styles/narrativeEditor.module.scss";


interface RemoveSectionModalProps {
    sectionTitle: string;
    isRemoving: boolean;
    errorMessage: string | null;
    onCancel: () => void;
    onConfirm: () => void;
}

export default function RemoveSectionModal(props: RemoveSectionModalProps): ReactElement {
    return (
        <Modal onClose={props.isRemoving ? undefined : props.onCancel}>
            <Header isDanger>Remove Section</Header>
            <Body>
                <p className={css.modalText}>
                    Remove <b>{props.sectionTitle}</b> from this summary? This can't be undone.
                </p>
                {props.errorMessage &&
                    <p className={css.modalError}>{props.errorMessage}</p>
                }
            </Body>
            <Footer>
                <FooterItem>
                    <Button isBasic disabled={props.isRemoving} onClick={props.onCancel}>
                        Cancel
                    </Button>
                </FooterItem>
                <FooterItem>
                    <Button isPrimary isDanger disabled={props.isRemoving} onClick={props.onConfirm}>
                        {props.isRemoving
                            ? <Inline size={24} aria-label="Removing section" />
                            : "Remove"
                        }
                    </Button>
                </FooterItem>
            </Footer>
            <Close aria-label="Close modal" />
        </Modal>
    );
}
